import { render } from "./verification_services_configurations.html?vue&type=template&id=05fc16d2&external"
import script from "./verification_services_configurations.js?vue&type=script&lang=js&external"
export * from "./verification_services_configurations.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__